export default __webpack_public_path__ + "static/media/oxygen.97675a2e.png";